import { render, staticRenderFns } from "./500.vue?vue&type=template&id=2a7a236f&scoped=true&"
var script = {}
import style0 from "./500.vue?vue&type=style&index=0&id=2a7a236f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a236f",
  null
  
)

export default component.exports